import { useCallback } from 'react';
import { DateResolution } from '../../../api/generated/data-contracts';
import { getToday, subPeriod, removeTime, getStartOf, addPeriod, getEndOf } from '../helpers';
import { DateRange } from '../types';
import { useUISettings } from '../../../context/network/http/QueryProvider/queries/UISettings';

export const useMinMaxDates = () => {
	const { data: uiSettings } = useUISettings();
	return useCallback((currentResolution: DateResolution): DateRange => {
		const { backward, forward, resolution } = uiSettings.settings.cacheContractConstraint;
		const today = getToday();

		let min = subPeriod(resolution, removeTime(getStartOf(resolution, today)), backward);
		if (getStartOf(currentResolution, min).getTime() < min.getTime()) {
			// We need to make sure the min date is within the cache contract constraint
			min = addPeriod(currentResolution, min, 1);
		}

		let max = addPeriod(resolution, removeTime(getEndOf(resolution, today)), forward);
		if (getEndOf(currentResolution, max).getTime() > max.getTime()) {
			// We need to make sure the max date is within the cache contract constraint
			max = subPeriod(currentResolution, max, 1);
		}

		return [min, max];
	}, [uiSettings.settings.cacheContractConstraint]);
};
